import { useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Dropdown from '../Dropdown/Dropdown'
import { selectDocumentState, setIsOnSubtopicsStep } from '../../redux/docSlice'
import { DOC_TEMPLATES } from '../../constants'
import './_AddMore.scss'
import { DocumentState } from '../../redux/types'
import ReplayIcon from '@mui/icons-material/Replay'
import AddIcon from '@mui/icons-material/Add'
import Revert from '../Modals/Revert'
import WordCount from '../Navbar/WordCount'
import { usePostHog } from 'posthog-js/react'
import AddMenu from '../Document/AddMenu'
import { Editor } from '@tiptap/core'

type AddMoreProps = {
	type: string | undefined
	docID: string
	isFixed: boolean
	editor: Editor
}

function AddMore({ type, docID, isFixed, editor }: AddMoreProps) {
	const closeAddMore = useRef(null)
	const dispatch = useDispatch()
	const documentState: DocumentState = useSelector((state) => selectDocumentState(state, docID))
	const [addMoreOpen, setAddMoreOpen] = useState(false)
	const [revertModalOpen, setRevertModalOpen] = useState(false)
	const posthog = usePostHog()

	const addMoreContent = <AddMenu editor={editor} appendAtEnd />

	return (
		<>
			<Revert
				docID={docID}
				closeModal={() => {
					setRevertModalOpen(false)
				}}
				isOpen={revertModalOpen}
			/>
			<div className={`flex addMoreContainer mt-6  ${isFixed ? 'fixed' : 'sticky'} visible`}>
				<div className="flex gap-4 justify-between w-full items-center">
					<div className={`flex items-center gap-1`}>
						{documentState.content && !documentState.isGenerating && !documentState.isTypingEssay && (
							<>
								<span
									className={`addMore ${addMoreOpen ? ' open ' : ''}`}
									onClick={() => {
										!documentState.isTypingEssay && setAddMoreOpen(!addMoreOpen)
										posthog.capture('add-more-clicked')
									}}
									ref={closeAddMore}
								>
									<AddIcon />
								</span>
							</>
						)}

						{!documentState.isGenerating && !documentState.isTypingEssay && type !== DOC_TEMPLATES.Blank && (
							<>
								<span
									className="revert"
									onClick={() => {
										setRevertModalOpen(true)
										dispatch(setIsOnSubtopicsStep({ docID: docID, isOnSubtopicsStep: false }))
									}}
								>
									<ReplayIcon />
								</span>
							</>
						)}
					</div>
					<div className={`flex gap-4 sm:hidden`}>
						<WordCount />
					</div>
				</div>

				{/* {documentState?.content && !documentState.isGenerating && documentState.isTypingAddMore && (
				<Basic
					onClick={() => {
						if (addMoreReader) addMoreReader.cancel()
					}}
					type="tertiary"
					CTA={<span>Stop autocomplete</span>}
					className="abortButton"
				/>
			)} */}
				<Dropdown
					open={addMoreOpen}
					setOpen={(val) => {
						setAddMoreOpen(val)
					}}
					body={addMoreContent}
					closeButton={closeAddMore}
					className={`addMoreDropdown absolute md:top-[-245px] top-[-300px] left-0 bg-white`}
				/>
			</div>
		</>
	)
}

export default AddMore
